<header>
  <nav class="navbar navbar-expand-lg navbar-light bg-light w-100 border-bottom">
    <div class="container">
      <a class="navbar-brand" href="/">
        <img src="/assets/discomon.png" alt="Discomon Logo" height="40" class="d-inline-block align-text-top me-2">
        <span class="text-muted small">by FlyIoT</span>
      </a>
      <button if={ props.isAuthenticated } class="navbar-toggler" type="button" data-bs-toggle="collapse"
        data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div if={ props.isAuthenticated } class="collapse navbar-collapse" id="navbarNav">
        <ul class="navbar-nav ms-auto">
          <!-- Dispositivos - Todos los usuarios -->
          <li class="nav-item">
            <button class="btn btn-link nav-link" onclick={ handleGoHome }>
              <i class="bi bi-house-door me-1"></i> Dispositivos
            </button>
          </li>

          <!-- Gestión RFID - Todos los usuarios -->
          <li class="nav-item">
            <button class="btn btn-link nav-link" onclick={ handleShowRfid }>
              <i class="bi bi-credit-card-2-front me-1"></i> Gestión RFID
            </button>
          </li>

          <!-- Separador visual para opciones de admin -->
          <li if={ isAdmin() } class="nav-item">
            <span class="navbar-text px-2 text-muted">|</span>
          </li>

          <!-- Gestión de Dispositivos/Usuarios - Solo Admin -->
          <li if={ isAdmin() } class="nav-item dropdown">
            <button class="btn btn-link nav-link dropdown-toggle" type="button" id="adminDropdown"
              data-bs-toggle="dropdown" aria-expanded="false">
              <i class="bi bi-gear me-1"></i> Administración
            </button>
            <ul class="dropdown-menu" aria-labelledby="adminDropdown">
              <li><a class="dropdown-item" href="#" onclick={ handleDeviceAdmin }>
                <i class="bi bi-hdd me-2"></i> Dispositivos
              </a></li>
              <li><a class="dropdown-item" href="#" onclick={ handleUserAdmin }>
                <i class="bi bi-people me-2"></i> Usuarios
              </a></li>
              <!-- Gestión de Firmware - Solo Admin -->
              <li><a class="dropdown-item" href="#" onclick={ handleShowFirmware }>
                <i class="bi bi-cpu me-1"></i> Firmwares
              </a></li>
            </ul>
          </li>
        </ul>

        <!-- User menu dropdown -->
        <user-dropdown onlogout={ handleLogout }></user-dropdown>
      </div>
    </div>

  </nav>

  <script>
    import UserDropdown from './user-dropdown.riot'
    import { AuthService } from '../services/api-service'

    export default {
      components: {
        UserDropdown
      },

      isAdmin() {
        return AuthService.isAdmin();
      },

      handleGoHome(e) {
        if (e) e.preventDefault();
        window.history.pushState({}, '', '/');
        window.dispatchEvent(new PopStateEvent('popstate'));
      },

      handleLogout() {
        if (this.props.onlogout) {
          this.props.onlogout();
        }
      },

      handleShowRfid(e) {
        if (e) e.preventDefault();
        if (this.props.onshowrfid) {
          this.props.onshowrfid();
        }
      },

      handleShowFirmware(e) {
        if (e) e.preventDefault();
        if (this.props.onadmin) {
          this.props.onadmin();
        } else {
          window.history.pushState({}, '', '/firmware-manager');
          window.dispatchEvent(new PopStateEvent('popstate'));
        }
      },

      handleDeviceAdmin(e) {
        if (e) e.preventDefault();
        window.history.pushState({}, '', '/create-device');
        window.dispatchEvent(new PopStateEvent('popstate'));
      },

      handleUserAdmin(e) {
        if (e) e.preventDefault();
        window.history.pushState({}, '', '/users');
        window.dispatchEvent(new PopStateEvent('popstate'));
      }
    }
  </script>

  <style>
    .navbar-nav .nav-link {
      padding: 0.5rem 1rem;
      color: #495057;
      transition: color 0.2s;
    }

    .navbar-nav .nav-link:hover {
      color: #0d6efd;
    }

    .navbar-nav .nav-link.active {
      color: #0d6efd;
      font-weight: 500;
    }

    /* Separador visual */
    .navbar-text {
      display: flex;
      align-items: center;
      height: 100%;
    }

    /* Mejora para dropdown en navbar */
    .navbar-nav .dropdown-menu {
      border: 1px solid #dee2e6;
      box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
    }

    .navbar-nav .dropdown-item {
      padding: 0.5rem 1rem;
      transition: background-color 0.2s;
    }

    .navbar-nav .dropdown-item:hover {
      background-color: #f8f9fa;
    }

    /* Responsive: ocultar separador en móvil */
    @media (max-width: 991px) {
      .navbar-text {
        display: none;
      }

      .navbar-nav .nav-item {
        border-bottom: 1px solid #e9ecef;
      }

      .navbar-nav .nav-item:last-child {
        border-bottom: none;
      }
    }
  </style>

</header>
